// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-wrapper[data-v-e7cb4b5a]{display:flex;flex-direction:row;align-items:center}.loading-wrapper[data-v-e7cb4b5a]  .spinner{margin-left:10px;width:14px;height:14px}.loading-wrapper[data-v-e7cb4b5a]  .spinner:after{display:none}", ""]);
// Exports
module.exports = exports;
